'use client';
import { getAnalysisScoreColor } from '@/app/calendar/day/ActivityAnalysisActions';
import { CoachButton } from '@/app/components/CoachButton';

type CoachSayCardProps = {
  coachSay: string | null | undefined;
  trainmeScore?: number | null;
  /** Source CoachMessage id, if this commentary is traceable to a chat message. */
  coachMessageId?: string | null;
};

export const CoachSayCard = ({
  coachSay,
  trainmeScore,
  coachMessageId,
}: CoachSayCardProps) => {
  if (!coachSay) {
    return null;
  }

  const scoreValue =
    typeof trainmeScore === 'number'
      ? Math.max(0, Math.min(trainmeScore, 1))
      : null;
  const scorePercent =
    scoreValue !== null ? Math.round(scoreValue * 100) : null;
  const fillColor =
    scoreValue !== null ? getAnalysisScoreColor(scoreValue) : null;

  return (
    <div className='h-full w-full space-y-3 rounded-2xl border border-gray-200 bg-gray-50 p-4 text-sm shadow-sm dark:border-slate-700 dark:bg-slate-900'>
      {scorePercent !== null && (
        <>
          <div className='flex items-center justify-between gap-4'>
            <div>
              <div className='text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-500 dark:text-slate-400'>
                TrainMe score
              </div>
              <div className='mt-1 text-lg font-semibold text-slate-900 dark:text-slate-100'>
                {scorePercent}
                <span className='text-xs text-slate-500 dark:text-slate-400'>
                  {' '}
                  / 100
                </span>
              </div>
            </div>
            <div className='text-xs uppercase tracking-[0.3em] text-slate-500 dark:text-slate-400'>
              AI Coach
            </div>
          </div>
          <div className='w-full rounded-full bg-slate-200 dark:bg-slate-800 h-3'>
            <div
              className='h-full rounded-full transition-all'
              style={{
                width: `${scorePercent}%`,
                background: fillColor ?? undefined,
              }}
            />
          </div>
        </>
      )}
      <div>
        <div className='flex items-center justify-between gap-3'>
          <div className='text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-500 dark:text-slate-400'>
            Coach insights
          </div>
          <CoachButton
            messageId={coachMessageId}
            className='btn btn-secondary rounded-full py-1 px-3 relative text-xs'
          />
        </div>
        <p className='mt-2 whitespace-pre-wrap text-sm leading-relaxed text-slate-800 dark:text-slate-100'>
          {coachSay}
        </p>
      </div>
    </div>
  );
};

export default CoachSayCard;
